export default "__VITE_ASSET__Imxaucx2__"